export interface CatalogBillState {
    id?: number;
    name?: string;
}

export const catalogStates: CatalogBillState[] = [
    {
      id: 2,
      name: "ASIG. VUELO",
    },
    {
      id: 3,
      name: "ENV. CUBA",
    },
    {
      id: 4,
      name: "RECEP. CUBA",
    },
    {
      id: 5,
      name: "ASIG. REPARTIDOR",
    },
    {
      id: 6,
      name: "RECEP. REPARTIDOR",
    },
    {
      id: 7,
      name: "ENTREGADA",
    },
    {
      id: 8,
      name: "CERR. CONTABLEMENTE",
    },
  ];   